// extracted by mini-css-extract-plugin
export default {"wrapper":"WizardTopText_wrapper__ljEyP","stepCounter":"WizardTopText_stepCounter__aXQeq","intro":"WizardTopText_intro__52SAq"};